module.exports = __webpack_public_path__ + "static/media/3_kolosa_71.88_84.35.e75c6280.png";